import { Dialog } from "construct-ui";
import moment from "moment";
import paginationComponent from "../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import { formats } from "../../../config/constants";
import SMECustomerIFModelMapModel from "../../../models/reports/sme-customer-if-model-map.model";
import ViewBase from "../../view-base.view";

export default function SMECustomerIFModelMapView() {
  ViewBase.call(this);

  let customers = [];
  let selectedCustomer;

  let interfaceModel = "";
  let samsungModel = "";

  const pagination = {
    pageIndex: 1,
    pageSize: 10,
    totalItems: 0,
  };

  let searchResult;

  let selectedCustomerAddNew;
  let interfaceModelAddNew = "";
  let samsungModelAddNew = "";

  let editedSamsungModelCode = "";
  let tempEditItem;

  let isAddModelMappingOpen = false;
  let isEditModelMappingOpen = false;

  const handleChangeIFModel = (e) => {
    interfaceModel = e.target.value;
  };
  const handleChangeSamsungModel = (e) => {
    samsungModel = e.target.value;
  };

  const handleSelectCustomer = (customer) => {
    selectedCustomer = customer;
  };

  const handleSelectCustomerAddNew = (customer) => {
    selectedCustomerAddNew = customer;
  };

  const handleChangeIFModelAddNew = (e) => {
    interfaceModelAddNew = e.target.value.trimStart();
  };

  const handleChangeSamsungModelAddNew = (e) => {
    samsungModelAddNew = e.target.value.trimStart();
  };

  const handleClearFilter = () => {
    selectedCustomer = undefined;
    interfaceModel = "";
    samsungModel = "";
  };

  const handlePageChanged = (page) => {
    pagination.pageIndex = page;
    fetchData();
  };

  const handlePageSizeChanged = (page, size) => {
    pagination.pageIndex = page;
    pagination.pageSize = size;
    fetchData();
  };


  const handleCloseAddNewModelMappingModal = () => {
    isAddModelMappingOpen = false;

    selectedCustomerAddNew = undefined;
    interfaceModelAddNew = "";
    samsungModelAddNew = "";
  };

  const handleCloseEditModelMappingModal = () => {
    isEditModelMappingOpen = false;
    editedSamsungModelCode = "";
    tempEditItem = undefined;
  };


  const handleClickDownloadResult = () => {
    this.showLoading();

    const config = {
      sMEEdiCustomerCode: selectedCustomer?.code,
      samsungChannel: interfaceModel,
      iFChannelAttr1: samsungModel,
      mapType: "MODEL_MAP",
      isExcelDownload: true,
    };

    SMECustomerIFModelMapModel.downloadSearchResult(config)
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const handleSubmit = (e) => {

    e.preventDefault();

    pagination.pageIndex = 1;
    fetchData();
  }

  const handleChangeSamsungModelEdit = (e) => {
    editedSamsungModelCode = e.target.value.trimStart();
  }

  const handleSubmitEdit = (e) => {
    e.preventDefault();
    e.target.classList.add("was-validated");

    if (!e.target.checkValidity()) {
      e.stopPropagation();
      return;
    }

    this.showLoading();

    let editedItem = {
      sMEEdiCustomerCode: tempEditItem.smeEdiCustomerCode,
      mapType: "MODEL_MAP",
      mapKey: tempEditItem.ifModel,
      mapAttribute1: editedSamsungModelCode.trimEnd(),
    };

    SMECustomerIFModelMapModel.update(editedItem)
      .then(() => {
        const onCloseMessage = () => {
          isEditModelMappingOpen = false;
          tempEditItem = undefined;
          editedSamsungModelCode = "";
          fetchData();
        };

        this.showMessage(
          this.getText("LT00001016", "Item edited successfully"),
          null,
          onCloseMessage
        );
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const handleClickDelete = (item) => {
    const handleConfirm = (action) => {
      if (action === "YES") {
        this.showLoading();

        let deleteItem = {
          sMEEdiCustomerCode: item.smeEdiCustomerCode,
          mapType: item.mapType,
          mapKey: item.ifModel,
          mapAttribute1: item.samsungModel,
          mapAttribute2: "",
        };

        SMECustomerIFModelMapModel.delete(deleteItem)
          .then(() => {
            pagination.pageIndex = 1;
            fetchData();
          })
          .catch((err) => {
            this.handleError(err);
          })
          .finally(() => {
            this.hideLoading();
          });
      }
    };

    this.showConfirm(
      this.getText(
        "LT00001017",
        "Are you sure you want to delete selected model mapping?"
      ),
      null,
      handleConfirm
    );
  };

  const handleClickEdit = (item) => {
    tempEditItem = item;
    editedSamsungModelCode = item.samsungModel;
    isEditModelMappingOpen = true;

  };

  const handleClickAdd = () => {
    isAddModelMappingOpen = true;
  };

  const handleSubmitAddNew = (e) => {

    e.preventDefault();
    e.target.classList.add("was-validated");

    if (!e.target.checkValidity()) {
      e.stopPropagation();
      return;
    }

    this.showLoading();

    let newItem = {
      sMEEdiCustomerCode: selectedCustomerAddNew.code,
      mapType: "MODEL_MAP",
      mapKey: interfaceModelAddNew.trimEnd(),
      mapAttribute1: samsungModelAddNew.trimEnd(),
    };

    SMECustomerIFModelMapModel.add(newItem)
      .then(() => {
        const onCloseMessage = () => {
          isAddModelMappingOpen = false;

          selectedCustomerAddNew = undefined;
          interfaceModelAddNew = "";
          samsungModelAddNew = "";

          fetchData();
        };

        this.showMessage(
          this.getText("LT00001018", "Item added successfully"),
          null,
          onCloseMessage
        );
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const fetchData = () => {
    this.showLoading();

    let queries = {
      sMEEdiCustomerCode: selectedCustomer?.code,
      iFModel: interfaceModel,
      samsungModel,
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex,
    };

    SMECustomerIFModelMapModel.search(queries)
      .then((searchRes) => {
        searchResult = searchRes.data || [];
        pagination.totalItems = searchRes.total;
        pagination.pageIndex = searchRes.pageIndex;
        pagination.pageSize = searchRes.pageSize;
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const fetchInitialData = () => {
    this.showLoading();

    SMECustomerIFModelMapModel.getCustomers()
      .then((customerRes) => {
        customers = customerRes;
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  return {
    oninit: () => {
      fetchInitialData();
    },

    view: () => {
      return [
        m(".d-md-flex.justify-content-end",
          m(".text-end",
            m("button.btn.btn-outline-primary.btn-add.mb-2",
              { onclick: handleClickAdd },
              m("i.bi.bi-plus-lg.me-0")
            )
          )
        ),

        m(".card.my-3",
          m(".card-body",
            m("form#form-search.row.g-2", { onsubmit: handleSubmit },
              m(".col-md-6.col-lg-3",
                m("label.form-label",
                  this.getText("LT00008046", "Customer")
                ),
                m(SingleSelectComponent, {
                  items: customers,
                  selectedItem: selectedCustomer,
                  onSelect: handleSelectCustomer,
                })
              ),

              m(".col-md-6.col-lg-3",
                m("label.form-label", this.getText("LT00001014", "I/F Model")),
                m('input.form-control.form-control-bg[type="text"][maxLength="50"]', {
                  placeholder: this.getText("LT00001014", "I/F Model"),
                  value: interfaceModel,
                  onchange: handleChangeIFModel,
                }),
              ),

              m(".col-md-6.col-lg-3",
                m("label.form-label", this.getText("LT00001013", "Samsung model")),
                m('input.form-control.form-control-bg[type="text"][maxLength="20"]', {
                  placeholder: this.getText("LT00001013", "Samsung model"),
                  value: samsungModel,
                  onchange: handleChangeSamsungModel,
                }),
              ),
            ),

            m(".row.g-2.justify-content-end.mt-2.mt-md-3",
              m(".col-12.gap-2.d-flex.justify-content-end.flex-wrap",
                m("button.btn.btn-primary[form='form-search']",
                  this.getText("LT00000001", "Search")
                ),

                m("button.btn.btn-white",
                  { onclick: handleClearFilter },
                  this.getText("LT00000031", "Clear")
                )
              )
            )
          )
        ),

        m(".card",
          m(".mt-2.me-2.text-end",
            m("a.btn.btn-primary",
              {
                class: !searchResult || searchResult.length === 0 ? "disabled" : "",
                onclick: handleClickDownloadResult,
              },
              m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
            )
          ),

          m(".mt-2",
            m(".row.mx-0",
              m(".col-12.p-0",
                m(".table-responsive",
                  m("table.table",
                    m("thead.thead-bggrey",
                      m("tr.align-middle",
                        m("th[scope=col]", this.getText("LT00008046", "Customer")),
                        m("th[scope=col]", this.getText("LT00001011", "Map Type")),
                        m("th[scope=col]", this.getText("LT00001014", "I/F Model")),
                        m("th[scope=col]", this.getText("LT00001013", "Samsung Model")),
                        m("th[scope=col]", this.getText("LT00000234", "Last Updated Date")),
                        m("th[scope=col]", this.getText("LT00001010", "Last Updated User Id")),
                        m("th[scope=col]", this.getText("LT00000092", "Action")),
                      )
                    ),
                    m("tbody",
                      searchResult?.length === 0 &&
                      m("tr",
                        { class: "align-middle" },
                        m("td",
                          { colspan: "100%" },
                          this.getText("EM00000141", "No records found.")
                        )
                      ),
                      searchResult?.length > 0 &&
                      searchResult.map((item) => {
                        return m("tr",
                          m("td", item.smeEdiCustomerCode),
                          m("td", item.mapType),
                          m("td", item.ifModel),
                          m("td", item.samsungModel),
                          m("td", moment(item.lastUpdatedDate).format(formats.LOCAL_TIME)),
                          m("td", item.lastUpdateUID),
                          m("td.center",
                            m('i.bi.bi-pencil-square.list-action-icon[title="Edit"]', {
                              onclick: () => { handleClickEdit(item) }
                            }),

                            m('i.bi.bi-trash-fill.list-action-icon[title="Delete"]', {
                              onclick: () => { handleClickDelete(item) }
                            }),
                          )
                        );
                      })
                    )
                  )
                ),
                searchResult?.length > 0 &&
                m(".px-3",
                  m(paginationComponent, {
                    currentPage: pagination.pageIndex,
                    pageSize: pagination.pageSize,
                    totalItems: pagination.totalItems,
                    data: searchResult,
                    onPageChanged: handlePageChanged,
                    onPageSizeChanged: handlePageSizeChanged,
                  })
                )
              )
            )
          )
        ),

        isAddModelMappingOpen &&
        m(Dialog, {
          class: "modal-body-overflow-visible",
          closeOnOutsideClick: false,
          isOpen: isAddModelMappingOpen,
          onClose: handleCloseAddNewModelMappingModal,
          title: this.getText("LT00000058", "Create"),
          content: m(".container",
            m(".card",
              m("form#form-add.card-body.needs-validation[novalidate]", { onsubmit: handleSubmitAddNew },
                m(".mt-2.position-relative",
                  m("label.form-label.mandatory[for='customers-add']",
                    this.getText("LT00008046", "Customer")
                  ),
                  m(SingleSelectComponent, {
                    id: "customers-add",
                    items: customers,
                    selectedItem: selectedCustomerAddNew,
                    onSelect: handleSelectCustomerAddNew,
                    required: true,
                  }),
                  m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                ),
                m(".mt-2.position-relative",
                  m("label.form-label.mandatory[for='if-model-add']", this.getText("LT00001014", "I/F Model")),
                  m('input#if-model-add.form-control.form-control-bg[type="text"][maxLength="50"]', {
                    placeholder: this.getText("LT00001014", "I/F Model"),
                    value: interfaceModelAddNew,
                    onchange: handleChangeIFModelAddNew,
                    required: true,
                  }),
                  m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                ),
                m(".mt-2.position-relative",
                  m("label.form-label.mandatory[for='samsung-model-add']", this.getText("LT00001013", "Samsung model")),
                  m('input#samsung-model-add.form-control.form-control-bg[type="text"][maxLength="20"]', {
                    placeholder: this.getText("LT00001013", "Samsung model"),
                    value: samsungModelAddNew,
                    onchange: handleChangeSamsungModelAddNew,
                    required: true,
                  }),
                  m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                ),
              )
            ),

            this.getBaseViews()
          ),
          footer: m("div.text-end",
            m("button.btn.btn-primary.me-2[form='form-add']", this.getText("LT00000022", "Save")),
            m("button.btn.btn-white",
              { onclick: handleCloseAddNewModelMappingModal },
              this.getText('LT00000021', "Close")
            )
          )
        }),

        isEditModelMappingOpen && tempEditItem &&
        m(Dialog, {
          class: "modal-body-overflow-visible",
          closeOnOutsideClick: false,
          isOpen: isEditModelMappingOpen,
          onClose: handleCloseEditModelMappingModal,
          title: this.getText("LT00000128", "Edit"),
          content: m(".container",
            m(".card",
              m("form#form-edit.card-body.needs-validation[novalidate]", { onsubmit: handleSubmitEdit },
                m(".mt-2",
                  m("label.form-label", this.getText("LT00008046", "Customer")),
                  m('input.form-control.form-control-bg[type="text"][disabled]', {
                    value: tempEditItem.smeEdiCustomerCode,
                  })
                ),
                m(".mt-2",
                  m("label.form-label", this.getText("LT00001014", "I/F Model")),
                  m('input.form-control.form-control-bg[type="text"][disabled]', {
                    value: tempEditItem.ifModel,
                  })
                ),
                m(".mt-2.position-relative",
                  m("label.form-label.mandatory", this.getText("LT00001013", "Samsung model")),
                  m('input.form-control.form-control-bg[type="text"][maxLength="20"]', {
                    value: editedSamsungModelCode,
                    required: true,
                    onchange: handleChangeSamsungModelEdit,
                  }),
                  m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
                ),
              )
            ),

            this.getBaseViews()
          ),
          footer: m("div.text-end",
            m("button.btn.btn-primary.me-2[form='form-edit']", this.getText("LT00000022", "Save")),
            m("button.btn.btn-white",
              { onclick: handleCloseEditModelMappingModal },
              this.getText("LT00000021", "Close")
            )
          )
        }),

        this.getBaseViews(),
      ];
    },
  };
}
